import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './styles/base.css'

import "./styles/base.css";
import "./styles/LightTheme.css";
import "./styles/DarkTheme.css";

const app = createApp(App)
app.use(router)
app.mount('#app')

// import { createApp } from "vue";
// import App from "./views/Main.vue";
//

//
// createApp(App).mount("#app");